import { NOT_LOGGED_IN_USER_ID } from '@ori/auth';
import type { PickClientAppDataConfigProps } from '@ori/client-app-config';

// This can be extended by specific types for your Online properties
export type ClientAppConfig = PickClientAppDataConfigProps<
  'currentLanguage' | 'customerId' | 'globalApiUrl' | 'identityUrl' | 'tenant'
>;

export const DEFAULT_CONFIG = {
  currentLanguage: document.documentElement.lang,
  customerId: NOT_LOGGED_IN_USER_ID,
  globalApiUrl: 'https://we-test-api.oriflame.com/uat',
  identityUrl: 'https://identity-uat.oriflame.com',
  tenant: 'uk',
};
